var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('v-alert',{attrs:{"text":"","prominent":"","type":"success"}},[_c('v-row',{attrs:{"align":"center","no-gutters":""}},[_c('v-col',{staticClass:"grow"},[_vm._v(" ログアウトしました。 ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }